import React from 'react'
import { DynamicHeading } from '@/components/molecules/DynamicHeading/DynamicHeading'
import { FeaturesSectionProps } from '@/components/organisms/FeaturesSection/types'
import { FeaturesTabs } from '@/components/molecules/FeaturesTabs/FeaturesTabs'
import { FeaturesAccordion } from '@/components/molecules/FeaturesAccordion/FeaturesAccordion'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'

export function FeaturesSection({ cards, heading, subtitle }: FeaturesSectionProps) {
  return (
    <section className="mx-auto max-w-screen-desktop p-24 laptop:px-90 laptop:py-64 overflow-hidden">
      <DynamicHeading
        {...heading[0]}
        className="text-headingM-mobile font-bold font-poppins text-text-dark-900 mx-auto w-full mb-24 netbook:text-headingM netbook:mb-16 text-center"
      />
      {subtitle && (
        <Paragraph className="mb-32 tablet:mb-64 text-center text-text-dark-600 text-bodyM tablet:text-bodyL">
          {subtitle}
        </Paragraph>
      )}
      <div className="hidden tablet:block">
        <FeaturesTabs cards={cards} />
      </div>
      <div className="block tablet:hidden">
        <FeaturesAccordion cards={cards} />
      </div>
    </section>
  )
}
